module.exports = __webpack_public_path__ + "static/media/inspector-icon.9a848872.svg";